export enum PresenceState {
  Online = 'ONLINE',
  LiveCoaching = 'LIVE_COACHING',
  Offline = 'OFFLINE',
}
